export default "__VITE_ASSET__CPbLgDxZ__"